.wrap {
  height: 100vh;
  height: 100svh;
  position: relative;
  background: var(--film-bg);
}
.sticky {
  position: relative;
  height: 100%;
  overflow: hidden;
}
.wrap[data-playback='scroll'] {
  height: 400vh;
  height: 400svh;
  height: var(--scrub-track-height, 400svh);
}
.wrap[data-playback='scroll'] .sticky {
  position: sticky;
  top: 0;
  height: 100vh;
  height: 100svh;
  height: 100dvh;
}
.video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  background: var(--film-bg);
  transform: scale(1.045);
  filter: brightness(1.02) contrast(0.93) saturate(0.97);
}
.toneWash {
  position: absolute;
  inset: 0;
  background: #d8dfe6;
  opacity: 0.15;
  pointer-events: none;
}
.blur {
  position: absolute;
  inset: 0;
  background: rgba(12, 9, 7, 0.3);
  backdrop-filter: blur(2.5px);
  -webkit-backdrop-filter: blur(2.5px);
  pointer-events: none;
}
.gradient {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 46vh;
  height: 46svh;
  height: calc(var(--scrub-viewport-height, 100svh) * 0.46);
  pointer-events: none;
  background: linear-gradient(
    to bottom,
    rgba(10, 8, 6, 0) 0%,
    rgba(10, 8, 6, 0.22) 42%,
    rgba(10, 8, 6, 0.5) 74%,
    rgba(10, 8, 6, 0.66) 100%
  );
}
.textLayer {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  pointer-events: none;
}
.t1 {
  margin-top: 42vh;
  margin-top: 42svh;
  margin-top: calc(var(--scrub-viewport-height, 100svh) * 0.42);
  text-align: center;
  opacity: 0;
  will-change: opacity, transform;
  font-family: var(--font-script);
  font-size: 52px;
  color: #f3f6f9;
  line-height: 1.25;
  letter-spacing: 1px;
  text-shadow:
    0 1px 2px rgba(16, 26, 43, 0.7),
    0 3px 10px rgba(16, 26, 43, 0.55),
    0 8px 26px rgba(16, 26, 43, 0.4);
}
.t2 {
  position: absolute;
  left: 0;
  right: 0;
  top: 44vh;
  top: 44svh;
  top: calc(var(--scrub-viewport-height, 100svh) * 0.44);
  text-align: center;
  opacity: 0;
  text-shadow: 0 1px 3px rgba(10, 8, 6, 0.5), 0 4px 16px rgba(10, 8, 6, 0.4);
}
.dateBadge {
  display: inline-block;
  border: 1px solid rgba(255, 255, 255, 0.55);
  border-radius: 999px;
  padding: 9px 22px;
  font-family: var(--font-hero);
  font-weight: 700;
  font-size: 18px;
  color: var(--cream);
  letter-spacing: 3px;
}
.placeLine {
  margin-top: 16px;
  font-family: var(--font-hero);
  font-size: 14.5px;
  color: rgba(255, 255, 255, 0.95);
  letter-spacing: 2.5px;
  line-height: 1.9;
}
.playButton {
  position: absolute;
  left: 50%;
  bottom: calc(40px + env(safe-area-inset-bottom, 0px));
  transform: translateX(-50%);
  min-width: 120px;
  min-height: 44px;
  padding: 12px 24px;
  border: 1px solid rgba(255, 255, 255, 0.6);
  border-radius: 999px;
  background: rgba(16, 26, 43, 0.75);
  color: #ffffff;
  font-family: var(--font-hero);
  font-size: 16px;
  cursor: pointer;
}
.playButton:focus-visible {
  outline: 2px solid #ffffff;
  outline-offset: 4px;
}
